import { useMutation, useQuery } from 'react-query';
import queryGetUsers from './queries/getUsers';
import queryGetProfiles from './queries/getProfiles';
import queryGetUser from './queries/getUser';
import mutationUpdateUserPassword from './mutations/updateUserPassword';
import mutationResetPassword from './mutations/resetPassword';
import mutationActivateUser from './mutations/activateUser';
import mutationDeactivateUser from './mutations/deactivateUser';
import mutationRemoveUser from './mutations/removeUser';
import mutationCreateUser from './mutations/createUser';
import mutationUpdatePermissions from './mutations/updatePermissions';

const actionsUsers = {
    // Getters
    getUser: (userId) => useQuery(queryGetUser(userId)),
    getUsers: (query, enabled) => useQuery(queryGetUsers(query, enabled)),
    getProfiles: (organizationId) => useQuery(queryGetProfiles(organizationId)),

    // Mutations
    // Password
    updatePassword: (onSuccess, onError) => useMutation(mutationUpdateUserPassword(onSuccess, onError)),
    resetPassword: (onSuccess, onError) => useMutation(mutationResetPassword(onSuccess, onError)),
    // User status
    activateUser: (onSuccess, onError) => useMutation(mutationActivateUser(onSuccess, onError)),
    deactivateUser: (onSuccess, onError) => useMutation(mutationDeactivateUser(onSuccess, onError)),
    removeUser: (onSuccess, onError) => useMutation(mutationRemoveUser(onSuccess, onError)),
    // User creation
    createUser: (onSuccess, onError) => useMutation(mutationCreateUser(onSuccess, onError)),
    // User permissions
    updatePermissions: (onSuccess, onError) => useMutation(mutationUpdatePermissions(onSuccess, onError))
};

export default actionsUsers;